// extracted by mini-css-extract-plugin
export var completionBody = "_jh-2";
export var completionCard = "_jh-0";
export var completionFooter = "_jh-3";
export var completionTitle = "_jh-1";